import { Box } from '@mui/material'
import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import AboutusImage from '../../assets/images/ThinkingHeader.webp'

const ThinkingBgLanding = () => {
  return (
    <Box sx={{
        width:"100%",
        paddingTop:{xs: '6rem',sm:'5rem'},
        backgroundColor:"#ecebeb",
    }} >
    <Box sx={{
        
    }} >
    <LazyLoadImage
          src={AboutusImage}
          effect="blur"
          width="100%"
          height="100%"
        />
    </Box>
    </Box>
  )
}

export default ThinkingBgLanding
